import { ReceiveCompanyPaymentMethod } from "../../../types/companiesTypes";

export const QTY_PERSONS = 2

export const receiveCompanyPaymentMethod = [
  {
		label: 'Bank',
		value: ReceiveCompanyPaymentMethod.Bank,
	},
  {
		label: 'Cash',
		value: ReceiveCompanyPaymentMethod.Cash,
	},
]

export const labelForConnectedPersons = [
  'First Person:', 'Second Person:'
]